import { render, staticRenderFns } from "./task-add.vue?vue&type=template&id=6f29d1b9&scoped=true&"
import script from "./task-add.vue?vue&type=script&lang=ts&"
export * from "./task-add.vue?vue&type=script&lang=ts&"
import style0 from "./task-add.vue?vue&type=style&index=0&id=6f29d1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f29d1b9",
  null
  
)

export default component.exports